import { S3DownloadButton } from '@/components/S3DownloadButton'
import { AuditTrail } from '@/hooks/queries/useAuditTrails'
import { AppCsvUploadType, CoreCsvUploadType, UploadScope } from '@repo/csv'
import { UPLOAD_S3_EVENT_TYPES } from '@repo/utils'

type AuditTrailS3DownloadButtonProps = {
  auditTrail: AuditTrail
}

export function AuditTrailS3DownloadButton(props: AuditTrailS3DownloadButtonProps) {
  if (
    !UPLOAD_S3_EVENT_TYPES.includes(
      props.auditTrail.eventType as (typeof UPLOAD_S3_EVENT_TYPES)[number],
    )
  )
    return

  // event_data is an untyped jsonb column; S3 upload events store flat string fields
  const data = props.auditTrail.eventDetails.data as Record<string, string>
  const uploadType = data['uploadType'] as AppCsvUploadType | CoreCsvUploadType
  const fileName = data['fileName']
  const scope = data['scope'] as UploadScope

  return <S3DownloadButton uploadType={uploadType} fileName={fileName} scope={scope} />
}
